import React, { useEffect } from "react"; // <-- add useEffect here

import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaCheckCircle, FaServer, FaNetworkWired, FaShieldAlt, FaCogs, FaArrowAltCircleRight } from "react-icons/fa";
import "aos/dist/aos.css";
import "../styles/DataCenter.css"; // Custom styles

const DataCenterSolution = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // <-- This forces scroll to top
  }, []);

  return (
    <div className="telecom-support-section">
      <Container fluid className="py-5 text-dark">
        <Container data-aos="fade-up">
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-right">
              <h3 className="fw-bold mb-3">Comprehensive Data Center Solutions</h3>
              <p className="lead">
                Our Data Center Solutions cover infrastructure design, setup, and ongoing support to ensure reliability, scalability, and efficiency for mission-critical operations.
              </p>
              <ul className="list-unstyled check-list">
                <li><FaCheckCircle className="me-2 text-success" /> Data center planning and design</li>
                <li><FaCheckCircle className="me-2 text-success" /> Server and network setup and configuration</li>
                <li><FaCheckCircle className="me-2 text-success" /> Power, cooling, and security management</li>
              </ul>
            </Col>
            <Col md={6} data-aos="fade-left">
              <video
                src="/videos/datacenter.mov"
                className="network-video mt-4"
                autoPlay
                loop
                muted
                playsInline
              />
            </Col>
          </Row>

          {/* <div className="divider my-5"></div> */}

          <h4 className="fw-bold text-center why-choose-heading why-choose-section">Key Services</h4>
          <Row className="g-4">
            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in">
                <Card.Body>
                  <FaServer className="icon" />
                  <Card.Title>Server Room Design</Card.Title>
                  <Card.Text>
                    Custom server room planning with optimal cooling, cabling, and power layout.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="100">
                <Card.Body>
                  <FaNetworkWired className="icon" />
                  <Card.Title>Structured Cabling</Card.Title>
                  <Card.Text>
                    High-performance structured cabling to support seamless data and communication flow.
                  </Card.Text>
                  <a href="#structured-cabling" className="read-more">
                    Read more <FaArrowAltCircleRight className="ms-1" />
                  </a>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="200">
                <Card.Body>
                  <FaShieldAlt className="icon" />
                  <Card.Title>Physical & Network Security</Card.Title>
                  <Card.Text>
                    Comprehensive security solutions to protect hardware and data assets.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in">
                <Card.Body>
                  <FaCogs className="icon" />
                  <Card.Title>Monitoring & Management</Card.Title>
                  <Card.Text>
                    Real-time monitoring tools and managed services for 24/7 uptime and performance.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="100">
                <Card.Body>
                  <FaServer className="icon" />
                  <Card.Title>Hardware Installation</Card.Title>
                  <Card.Text>
                    Professional deployment of servers, storage devices, and switches.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="200">
                <Card.Body>
                  <FaCogs className="icon" />
                  <Card.Title>Capacity Planning</Card.Title>
                  <Card.Text>
                    Plan for future growth with scalable and efficient infrastructure layouts.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* <div className="divider my-5"></div> */}

          <h4 className="fw-bold text-center why-choose-heading why-choose-section">Why Choose Us?</h4>
          <ul className="list-unstyled row check-list-lg justify-content-center">
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Certified data center professionals</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> High-performance, low-latency networks</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Tier III & IV compliant design</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Custom-built scalable infrastructure</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> 24/7 monitoring and on-call support</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Trusted by global enterprises</li>
          </ul>

          <div className="text-center mt-5">
            <Button variant="primary" href="/contact" className="cta-button">
              Contact Us
            </Button>
          </div>
        </Container>
      </Container>
    </div>
  );
};

export default DataCenterSolution;
